/*
 * File: DeliveryDetailsStep.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 28 Dec 2021 2:47:56 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Col, Row, Space, Typography } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';
import { DeliveryDetails } from '../molecules/DeliveryDetails';

const styles: InlineStylesModel = {
  titleRow: {
    height: 60,
    padding: '0px 20px',
    backgroundColor: '#b0b2bc'
  },
  title: {
    marginBottom: 0
  },
  mainContainer: {
    backgroundColor: 'white',
    padding: '30px',
    height: '75vh'
  }
};

export const DeliveryDetailsStep = (): JSX.Element => {
  return (
    <>
      <Row style={styles.titleRow}>
        <Space size="large">
          <Col>
            <Typography.Title level={4} style={styles.title}>
              Delivery Details
            </Typography.Title>
          </Col>
        </Space>
      </Row>

      <Row style={styles.mainContainer}>
        <DeliveryDetails />
      </Row>
    </>
  );
};
